import { AllocationScenarioValuationModel } from 'api';
import { ValuationsApproach } from 'common/types/valuation';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { EquityAllocationCellCustomData } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config';
import { ValuationSummaryCellCustomData } from 'pages/ValuationsAllocation/approaches/ValuationSummary/config';
import {
  OnChangeType,
  UpdateAllocationScenariosWithRelated,
} from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { isScenarioWeightingProbabilityCell } from 'pages/ValuationsAllocation/util/cellValidators';

interface HandleScenarioWeightingProbabilityParams {
  cell: ICell<ValuationSummaryCellCustomData | EquityAllocationCellCustomData>;
  allocationScenarios: AllocationScenarioValuationModel[];
  approaches: ValuationsApproach[];
  cells: any;
  onChange: OnChangeType;
  updateAllocationScenariosWithRelated: UpdateAllocationScenariosWithRelated;
}

/**
 * Handles changes to scenario weighting probability cells.
 * Synchronizes scenario weighting probability across valuation summary and equity allocation sheets.
 */
export const handleScenarioWeightingProbability = async (
  params: HandleScenarioWeightingProbabilityParams
): Promise<void> => {
  const { cell, allocationScenarios, approaches, cells, onChange, updateAllocationScenariosWithRelated } = params;

  if (!isScenarioWeightingProbabilityCell(cell)) {
    return;
  }

  await updateAllocationScenariosWithRelated(
    {
      allocationScenarios,
      approaches,
    },
    cells,
    onChange
  );
};
